import type { ClientSuggestionCategory } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useGetSuggestionCategories } from '@/features/api/hooks/grapevine-suggestion/useGetSuggestionCategories';
import { PostEditorModalShell } from '@/features/post-editor/components/editor/PostEditorModalShell';
import { SuggestionCategorySelection } from '@/features/post-editor/components/SuggestionCategorySelection';
import { PostForm } from '@/features/post-editor/constants/form';
import type { PostFormValues } from '@/features/post-editor/types/postForm';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

type Props = {
  isVisible: boolean;
  onClose: () => void;
};

export const PostCategoryModal: FC<Props> = ({ isVisible, onClose }) => {
  const { t } = useTranslation(LocalizationNameSpace.POST_CREATION, {
    keyPrefix: 'screens.post-editor'
  });
  const { control } = useFormContext<PostFormValues>();

  const { data: suggestionCategories } = useGetSuggestionCategories();

  const category = useController({ control, name: 'suggestionCategory' });

  const handleSelect = (selected: ClientSuggestionCategory) => {
    if (selected) category.field.onChange(selected);
    onClose();
  };

  return (
    <PostEditorModalShell
      isVisible={isVisible}
      title={t(PostForm.CATEGORY)}
      onClose={onClose}
    >
      <SuggestionCategorySelection
        selected={category.field.value}
        suggestionCategories={suggestionCategories ?? []}
        onSelect={handleSelect}
      />
    </PostEditorModalShell>
  );
};
